import { SCREEN_BREAKPOINT } from "./BaseConstants"

export const isMobile = navigator.userAgent.includes("Mobi")

export const isSmallScreen = window.innerWidth < SCREEN_BREAKPOINT.lg
